// extracted by mini-css-extract-plugin
module.exports = {"ArticleByline":"ArticleByline_ArticleByline__2fzlT","ArticleByline_name":"ArticleByline_ArticleByline_name__R406Z","ArticleByline_title":"ArticleByline_ArticleByline_title__17LAh"};